import React from 'react';
import { useNavigate } from 'react-router-dom';

const Error404Page = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center">
        <div className="">
          <h1 className="text-8xl font-extrabold text-gray-900">
            404
          </h1>
        </div>
        
     
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 opacity-0 animate-fade-in">
          ¡No deberías andar por aquí!
        </h2>

        {/* Imagen sin card, solo con animación suave */}
        <div className="w-64 h-64 mx-auto transform transition-transform duration-300 hover:scale-105">
          <img 
            src="https://cdn-icons-gif.flaticon.com/6416/6416387.gif" 
            alt="devuelvan el neko arc 404" 
            className="w-full h-full object-contain"
          />
        </div>

       
        <p className="text-xl text-gray-600 mb-4">
          La página que buscas no ha sido encontrada
        </p>

        {/* Botón de regreso con hover effect */}
        <button
  onClick={() => navigate('/')}
  className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white px-6 py-3 rounded-lg transition-all duration-200 transform hover:scale-105"
>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    className="h-4 w-4" 
    fill="none" 
    viewBox="0 0 24 24" 
    stroke="currentColor"
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth={2} 
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" 
    />
  </svg>
  Regresar al inicio
</button>

      </div>

      <style jsx>{`
        @keyframes fade-in {
          from { 
            opacity: 0; 
            transform: translateY(-20px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Error404Page;